import { getPreferredSlider, updatePreferredSlider } from '../services/vu';
import { fetchSlidersIfNeeded } from './sliders';

export const fetchDefaultSliderIfNeeded = (courseId, parentSSPNo) => {
  return (dispatch, getState) => {
    if (shouldFetchDefaultSlider(getState(), courseId)) {
      return dispatch(fetchDefaultSlider(courseId, parentSSPNo));
    } else {
      return Promise.resolve();
    }
  };
};

const fetchDefaultSlider = (courseId, parentSSPNo) => {
  return (dispatch, getState) => {
    dispatch(requestDefaultSlider(courseId));

    return dispatch(fetchSlidersIfNeeded(courseId, parentSSPNo))
      .then(() => {
        return getPreferredSlider(courseId).then(
          ({ sliderId: preferredSliderId }) => {
            const {
              courses: { selectedCourseCode },
              sliders: slidersByCourse
            } = getState();

            const sliders = slidersByCourse[selectedCourseCode].data;

            const defaultSlider = calculateDefaultSlider(
              courseId,
              preferredSliderId,
              sliders
            );

            if (defaultSlider && defaultSlider !== preferredSliderId) {
              dispatch(fetchAndUpdatePreferredSlider(courseId, defaultSlider));
            } else {
              dispatch(receiveDefaultSlider(courseId, defaultSlider));
            }
          }
        );
      })
      .catch(() => {
        dispatch(requestDefaultSliderError(courseId));
      });
  };
};

const shouldFetchDefaultSlider = (state, courseId) => {
  const { sliders } = state;

  return sliders[courseId].defaultSlider === null;
};

const calculateDefaultSlider = (courseId, sliderIdFromApi, sliders = []) => {
  const sliderFromApi = sliders.find(slider => slider.id === sliderIdFromApi);
  if (sliderFromApi) {
    return sliderIdFromApi;
  }

  if (sliders.length > 0) {
    return sliders[0].id;
  }

  return null;
};

export const fetchAndUpdatePreferredSlider = (courseId, sliderId) => {
  return dispatch => {
    return updatePreferredSlider(courseId, sliderId).then(() => {
      return dispatch(receiveDefaultSlider(courseId, sliderId));
    });
  };
};

const requestDefaultSlider = courseId => {
  return {
    type: 'REQUEST_DEFAULT_SLIDER',
    courseId
  };
};

const requestDefaultSliderError = courseId => {
  return {
    type: 'REQUEST_DEFAULT_SLIDER_ERROR',
    courseId
  };
};

const receiveDefaultSlider = (courseId, sliderId) => {
  return {
    type: 'RECEIVE_DEFAULT_SLIDER',
    courseId,
    sliderId
  };
};
